export default function DataSection() {
  const stats = [
    {
      number: '86%',
      description: 'のユーザーが来店前にネット検索',
      subtext: 'HPがないと選択肢にすら入れない'
    },
    {
      number: '70%',
      description: 'がスマホ非対応のHPで離脱',
      subtext: '古いHPは逆効果になることも'
    },
    {
      number: '0件',
      description: '検索で見つからない＝新規集客ゼロ',
      subtext: '口コミ頼みでは成長に限界'
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-900">
      <div className="max-w-6xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            HPがないと、こんなに損してます
          </h2>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <div 
              key={index}
              className="text-center p-8 bg-slate-800 rounded-2xl border-2 border-cyan-600 hover:bg-slate-700 transition-all duration-300"
            >
              <div className="text-6xl sm:text-7xl font-bold text-amber-500 mb-4">
                {stat.number}
              </div>
              <p className="text-xl font-semibold text-white mb-3">
                {stat.description}
              </p>
              <p className="text-cyan-300">
                {stat.subtext}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}